import React, { useEffect, useState } from "react";
import { FETCH_CLIENTS_API } from "../../Api";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import "../../../../../st-website/src/App.css";

const ClientsCarousel = () => {
  const [clientsData, setClientsData] = useState([]);

  async function fetchClientsFromServer() {
    try {
      const response = await fetch(FETCH_CLIENTS_API);
      const data = await response.json();
      setClientsData(data);
      console.log("Fetched clients:", data);
    } catch (error) {
      console.error("Error fetching clients:", error);
    }
  }

  useEffect(() => {
    fetchClientsFromServer();
  }, []);

  // Initialize Embla Carousel instances
  const [emblaRef1] = useEmblaCarousel(
    { loop: true, speed: 5 },
    [Autoplay({ delay: 1000, reverse: true, stopOnInteraction: false })]
  );

  return (
    <div className="bg-white text-black flex flex-col items-center py-4 sm:py-6 md:py-8 lg:py-10 px-2 sm:px-4 md:px-8">
      <div className="w-full flex flex-col items-center space-y-4 sm:space-y-6">
        <div
          className="w-[90%] max-w-6xl overflow-hidden max-h-20"
          ref={emblaRef1}
        >
          <div className="flex gap-x-2 sm:gap-x-4">
            {clientsData.map((client) => (
              <div key={client.id} className="flex-shrink-0 p-1">
                <img
                  src={client.imgSrc}
                  alt={client.name}
                  className="object-contain w-24 h-10 sm:w-28 sm:h-12 md:w-32 md:h-14 lg:w-36 lg:h-16"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientsCarousel;
